import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=672bf43f&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=672bf43f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bf43f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672bf43f')) {
      api.createRecord('672bf43f', component.options)
    } else {
      api.reload('672bf43f', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=672bf43f&scoped=true", function () {
      api.rerender('672bf43f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/receivables/Create.vue"
export default component.exports